import { render, staticRenderFns } from "./ClientComplaintsForm.vue?vue&type=template&id=56e47985&"
import script from "./ClientComplaintsForm.vue?vue&type=script&lang=ts&"
export * from "./ClientComplaintsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports